import request from '../../utils/request'

// 查询
export function create (data) {
  return request.post('/business/static/create', data, {
    trim: true
  })
}

